var SupportOrdersIteratorNonPaginatedCollection;

SupportOrdersIteratorNonPaginatedCollection = (function() {
  function SupportOrdersIteratorNonPaginatedCollection(ordersFilter, orderModel) {
    this.ordersFilter = ordersFilter;
    this.resetIterator();
    this.size = 10;
    if (orderModel.hasOrders()) {
      this.state = "SUCCESS";
      this.ordersFilter.sortOrders(_.map(orderModel.orders, function(order) {
        return order;
      }));
    } else {
      this.state = "NOT_STARTED";
    }
  }

  SupportOrdersIteratorNonPaginatedCollection.prototype.resetIterator = function() {
    return this.currentOrdersOffset = 0;
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.resetState = function() {
    return this.state;
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.hasNext = function() {
    if (this.isStateNotStarted()) {
      return true;
    } else if (this.isOrderCallQueued() || this.currentOrdersOffset >= this.getNumberOfOrdersFetched()) {
      return false;
    }
    return true;
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.next = function(sucessCallback, errorCallback) {
    var _errorCb, _sucessCb, options;
    if (this.hasNext()) {
      _sucessCb = (function(_this) {
        return function() {
          var offset;
          _this.state = "SUCCESS";
          offset = _this.currentOrdersOffset;
          _this.currentOrdersOffset = Math.min(_this.currentOrdersOffset + _this.size, _this.getNumberOfOrdersFetched());
          return sucessCallback(_this.ordersFilter.sortedOrders.slice(offset, offset + _this.size));
        };
      })(this);
      if (this.currentOrdersOffset < this.getNumberOfOrdersFetched()) {
        return _sucessCb();
      } else {
        options = {};
        this.state = "QUEUED";
        _errorCb = (function(_this) {
          return function() {
            _this.state = "ERROR";
            return errorCallback();
          };
        })(this);
        return this.ordersFilter.getOrders(options, _sucessCb, _errorCb);
      }
    }
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.isStateNotStarted = function() {
    return this.state === "NOT_STARTED";
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.isOrderCallQueued = function() {
    return this.state === "QUEUED";
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.hasOrderCallFailed = function() {
    return this.state === "ERROR";
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.getNumberOfOrdersFetched = function() {
    return this.ordersFilter.sortedOrders.length;
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.getNumberOfItemPerPage = function() {
    return this.size;
  };

  SupportOrdersIteratorNonPaginatedCollection.prototype.isOrdersInfoValid = function() {
    return !(this.isStateNotStarted() || this.hasOrderCallFailed());
  };

  return SupportOrdersIteratorNonPaginatedCollection;

})();

module.exports = SupportOrdersIteratorNonPaginatedCollection;

//# sourceMappingURL=data:application/json;base64,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
